import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnInit,
    Renderer2,
    ViewEncapsulation,
    Input,
} from '@angular/core';
import { routerTransition } from '@fi-app/utilities/tabs/navigation-tabs/tabs-router.animations';
import { TabsComponent } from '@fi-app/utilities/tabs/tabs.component';

@Component({
    selector: 'fi-navigation-tabs',
    template: `
        @if (!isNavBarHidden) {
          <div class="fi-tabs-header-container">
            <ng-content select="header-left-content"></ng-content>
            <nav
              mat-tab-nav-bar
              [mat-stretch-tabs]="false"
              [tabPanel]="tabPanel"
              (swipeleft)="swipeLeft($event)"
              (swiperight)="swipeRight($event)"
              >
              @for (tab of tabsModel; track tab; let index = $index) {
                <a
                  mat-tab-link
                  class="CcmTab"
                  [active]="selectedIndex === index"
                  (click)="selectIndex(index)"
                  [disabled]="tab.IsDisabled"
                  >
                  {{ tab.Title }}
                  @if (tab.count$ && (tab.count$ | async); as count) {
                    <span class="count BrandedBackgroundColor">
                      {{ count }}
                    </span>
                  }
                </a>
              }
            </nav>
            <ng-content select="header-right-content"></ng-content>
          </div>
        }
        
        <div class="fi-tabs-router-container" [@routerTransition]="selectedIndex">
          <mat-tab-nav-panel #tabPanel>
            <ui-view></ui-view>
          </mat-tab-nav-panel>
        </div>
        `,
    styleUrls: ['./navigation-tabs.component.scss'],
    animations: [routerTransition],
    host: { class: 'fi-navigation-tabs' },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavigationTabsComponent extends TabsComponent implements OnInit {
    @Input() isNavBarHidden: boolean;

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef,
    ) {
        super();
    }

    ngOnInit(): void {
        this.renderer.removeClass(this.elementRef.nativeElement, this.tabsComponentClassName);
    }
}
